import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemOverview } from './components/SystemOverview';
import { InsideCarousel } from './components/InsideCarousel';
import { Testimonials } from './components/Testimonials';
import { TomosSection } from './components/TomosSection';
import { ClassLibrary } from './components/ClassLibrary';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { WhyDifferent } from './components/WhyDifferent';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
type MetaWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
const META_PIXEL_ID = '1367632915547845';
export function App() {
  useEffect(() => {
    const w = window as MetaWindow;
    try {
      if (!w.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as MetaPixel;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        w.fbq = pixel;
        if (!w._fbq) w._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-background font-sans text-foreground antialiased" data-id="element-0" data-mp="34nbhsjeuzx5">
      <noscript data-id="element-1" data-mp="3uc9jtyh2rqkc">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3uevrrz7vo833" />
      </noscript>
      <main data-id="element-3" data-mp="3gkuxpirvf992">
        <Hero data-id="element-4" data-mp="3gmfulf1nr4a3" />
        <InsideCarousel data-id="element-5" data-mp="3glwcnyc0cfw2" />
        <Testimonials data-id="element-6" data-mp="3gja35t5k3qb7" />
        <PainPoints data-id="element-7" data-mp="3bmjq7ep1tau0" />
        <SolutionReveal data-id="element-8" data-mp="3bn30c98giuxh" />
        <SystemOverview data-id="element-9" data-mp="3bnuudfmeokln" />
        <TomosSection data-id="element-10" data-mp="3bkgr855x47d5" />
        <ClassLibrary data-id="element-11" data-mp="3qaxtfqqdn1b3" />
        <WhyDifferent data-id="element-12" data-mp="3qc97cjdjdpfx" />
        <BonusSection data-id="element-13" data-mp="3qcqy50hfjbgg" />
        <PricingSection data-id="element-14" data-mp="3qd0rmy1oo0qw" />
        <Guarantee data-id="element-15" data-mp="3lkr4tqvv7gsu" />
        <FAQ data-id="element-16" data-mp="3lk7pmhxln6ii" />
        <FinalCTA data-id="element-17" data-mp="3ljpiurdb99wc" />
      </main>
      <Footer data-id="element-18" data-mp="3liehey7c8e8e" />
      <PurchaseNotifications data-id="element-19" data-mp="2xuwsdafgju94" />
    </div>;
}